<template>
  <div class="lot">
    <span :class="status.class" class="label label-wrap big-label pull-right">
      {{ status.text }}
    </span>
    <div class="row">
      <div class="col-sm-4">
        <span class="label big-label label-success">
          <strong>#{{ lot.lotId }}</strong>
        </span>
        <h4>{{ lot.address }}</h4>
        <img :src="lotLocation" alt="Lot Location" class="google-map">
        <br/><br/>
        <p>
          <em>{{ lot.addressMemo }}</em>
        </p>
      </div>
      <div class="col-sm-4">
        <div class="row">
          <checkbox-input
            :options="{ fullWidth: true, label: 'Weekend Rate Enabled:' }"
            :value="lot.hasWeekend"
            @input="toggleWeekend(lot)">
          </checkbox-input>
        </div>
        <div class="row">
          <checkbox-input
            :options="{ fullWidth: true, label: 'Overnight Rate Enabled:' }"
            :value="lot.hasOvernight"
            @input="toggleOvernight(lot)">
          </checkbox-input>
        </div>
        <div class="row">
          <checkbox-input
            :options="{ fullWidth: true, label: 'One Way Trips Enabled:' }"
            :value="lot.oneWayTrips"
            @input="toggleOneWayTrips(lot)">
          </checkbox-input>
        </div>
        <p><strong>Bays: </strong> {{ lot.bays }}</p>
        <p><strong>Lot Type: </strong> {{ lot.lotType }}</p>
        <p><strong>Cost: </strong> {{ lot.cost | to_dollar_amount }}</p>
        <p><strong>LGA: </strong> {{ lot.municipality }}</p>
      </div>
      <div class="col-sm-4">
        <p><strong>Cellular Reception:</strong> {{ lot.cellularReception }}</p>
        <p><strong>Emergency Contact:</strong><br/> {{ lot.emergencyContact }}</p>
        <template v-if="lot.premiumName">
          <h4>Lot Premium</h4>
          <p><strong>Premium:</strong> {{ lot.premiumName }}</p>
          <p><strong>Premium Cost:</strong> {{ lot.premiumAmount }}</p>
          <p><strong>Premium Message:</strong><br/> {{ lot.premiumReason }}</p>
        </template>
      </div>
    </div>
    <div class="toolbar text-right">
      <router-link class="btn btn-sm btn-primary" :to="'/fleet/lots/edit/' + lot.uuid">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
      <button v-if="!lot.closed" @click="close(lot)" class="btn btn-sm btn-danger" :disabled="parseInt(lot.carsCount) > 0">
        <span class="fa fa-ban fa-fw"></span> Close Lot
      </button>
      <button v-if="lot.closed" @click="open(lot)" class="btn btn-sm btn-success">
        <span class="fa fa-undo fa-fw"></span> Reopen Lot
      </button>
    </div>
  </div>
</template>

<script>
import CheckboxInput from '@/components/inputs/CheckboxInput'
import { mapActions } from 'vuex'
import {
  OPEN_LOT,
  CLOSE_LOT,
  TOGGLE_LOT_OVERNIGHT,
  TOGGLE_LOT_WEEKEND,
  TOGGLE_LOT_ONE_WAY_TRIPS
} from '@/vuex/types'
export default {
  name: 'LotRow',
  props: {
    object: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  components: {
    CheckboxInput
  },
  computed: {
    status () {
      if (parseInt(this.lot.carsCount) === 0 && !this.lot.closed) {
        return { class: 'label-danger', text: 'Lot Empty' }
      } else if (parseInt(this.lot.carsCount) > 0) {
        if (this.lot.bays > parseInt(this.lot.carsCount)) {
          return { class: 'label-primary', text: 'Bays Available: ' + (this.lot.bays - this.lot.carsCount) }
        } else {
          return { class: 'label-warning', text: 'Lot Full' }
        }
      } else {
        return { class: 'label-default', text: 'Lot Closed' }
      }
    },
    googleLink () {
      return 'https://maps.google.com/?q=' + this.lot.latitude + ',' +
      this.lot.longitude
    },
    lotLocation () {
      return 'https://maps.googleapis.com/maps/api/staticmap?center=' +
      this.lot.latitude + ',' + this.lot.longitude + '&zoom=17&size=250x250' +
      '&maptype=roadmap&markers=color:red%7Clabel:C%7C' +
      this.lot.latitude + ',' + this.lot.longitude +
      '&key=AIzaSyChsNbsujgDDgecCVkJNUkG2WFntMXPZ4c'
    },
    lot () {
      return {
        ...this.object,
        ...this.updatedLot
      }
    }
  },
  data () {
    return {
      updatedLot: {}
    }
  },
  methods: {
    async executeAction (action, payload) {
      let result = await this[action](payload)
      if (result && result.updated) this.updatedLot = result.updated
    },
    toggleOvernight (lot) {
      this.executeAction(TOGGLE_LOT_OVERNIGHT, lot)
    },
    toggleWeekend (lot) {
      this.executeAction(TOGGLE_LOT_WEEKEND, lot)
    },
    toggleOneWayTrips (lot) {
      this.executeAction(TOGGLE_LOT_ONE_WAY_TRIPS, lot)
    },
    close (lot) {
      this.executeAction(CLOSE_LOT, lot)
    },
    open (lot) {
      this.executeAction(OPEN_LOT, lot)
    },
    ...mapActions([
      OPEN_LOT,
      CLOSE_LOT,
      TOGGLE_LOT_OVERNIGHT,
      TOGGLE_LOT_WEEKEND,
      TOGGLE_LOT_ONE_WAY_TRIPS
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cards/Lot.vue